export default __webpack_public_path__ + "static/media/html5-logo.ed98f3fc.svg";